<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VEPMkn/tc-custom/9781683351924.jpg?1705952123237" alt="This image is the cover for the book Rosie Revere's Big Project Book for Bold Engineers, The Questioneers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rosie Revere's Big Project Book for Bold Engineers, The Questioneers
      </h1>
      <p class="bookDescription body article font2">
        <p>With more than 40 things to invent, draw, and make, featuring art from the beloved New York Times bestselling picture book Rosie Revere, Engineer, this activity book contains kid-friendly projects of all kinds and is the perfect gift for curious young readers! Soon enough children will be engineering whizzes just like Rosie, and along the way she’ll reassure them that failure, flops, mess-ups and cross-outs are part of the process. Do you like to make things? Dream up gadgets to improve your life and the lives of others? Then you are ready to join Rosie Revere and become a great engineer!  Build a Solar Oven Make a Simple Catapult Design a Better Bicycle Collect “Engineer’s Treasure” And much more!  Engineering is persevering, and this book is the perfect place for trying out, crossing out, and trying again. There is no better way to introduce would-be engineers to science and engineering than with their new best friend, Rosie. It’s fun for them and a great way for parents who want to get their kids excited about STEM (science, technology, engineering, math) in school. And now you can follow Rosie’s further adventures—with her friends Iggy Peck and Ada Twist—in the instant New York Times bestseller Rosie Revere and the Raucous Riveters, a chapter book starring The Questioneers! Don’t miss these STEM favorites! Rosie Revere, Engineer Iggy Peck, Architect Ada Twist, Scientist Iggy Peck’s Big Project Book for Amazing Architects Rosie Revere and the Raucous Riveters Ada Twist and the Perilous Pants Ada Twist’s Big Project Book for Stellar Scientists</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrea Beaty, David Roberts
      </h2>
      
      <p class="authorDescription body article">Andrea Beaty is the author of Iggy Peck, Architect and Rosie Revere, Engineer, among other children’s titles. She lives just outside Chicago. David Roberts has illustrated many children’s books, including Iggy Peck, Architect; Rosie Revere, Engineer; and Ada Twist, Scientist. He lives in London, where, when not drawing, he likes to make hats.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67370116